import { injectable } from "inversify";
import QARepository from "../../repositories/qa.repository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import QAQuestionEntity from "../../entities/qa_question.entity";

interface _Props {
    qaRepository: QARepository;
}
@injectable()
export default class UpdateQuestionForAgentUseCase {
    private qaRepository: QARepository;
    constructor(props: _Props) {
        this.qaRepository = props.qaRepository;
    }
    public call = async (question: QAQuestionEntity): Promise<Either<ErrorEntity, QAQuestionEntity>> => {
        console.log("question getted use case", question);
        return this.qaRepository.updateQuestionFromAgent(question);
    }
}

export const UpdateQuestionForAgentUseCaseName = "UpdateQuestionForAgentUseCase";